import { Bounce, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useMilkEntry } from "./milk-entry/useMilkEntry";
import MilkEntryForm from "./milk-entry/MilkEntryForm";
import { ReceiptPrintTemplate } from "../../utils/printReceipt";
import {ReceiptModal,PriceWarningModal,MissingCustomerModal} from "./milk-entry/milkEntryModals";

function MilkEntries({ userId, smallScreen, role, Name }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    inputs,
    time,
    setTime,
    animalType,
    setAnimalType,
    calculationType,
    setCalculationType,
    isAutoIncrement,
    setIsAutoIncrement,
    showReceiptAfterSubmit,
    setShowReceiptAfterSubmit,
    showReceiptPopup,
    setShowReceiptPopup,
    receiptData,
    receiptRef,
    showPriceWarning,
    setShowPriceWarning,
    isOpen,
    setIsOpen,
    weightRef,
    fatRef,
    snfRef,
    priceRef,
    handleChange,
    finalTotal,
    handleSubmit,
    handleRedirectToSettings,
    printReceipt,
    shareReceipt,
  } = useMilkEntry({ userId, role, Name, t, navigate });

  return (
    <div className="max-w-lg">
      <ReceiptPrintTemplate ref={receiptRef} receiptData={receiptData} t={t} />

      <MilkEntryForm
        t={t}
        inputs={inputs}
        calculationType={calculationType}
        setCalculationType={setCalculationType}
        animalType={animalType}
        setAnimalType={setAnimalType}
        time={time}
        setTime={setTime}
        handleChange={handleChange}
        weightRef={weightRef}
        fatRef={fatRef}
        snfRef={snfRef}
        priceRef={priceRef}
        isAutoIncrement={isAutoIncrement}
        setIsAutoIncrement={setIsAutoIncrement}
        showReceiptAfterSubmit={showReceiptAfterSubmit}
        setShowReceiptAfterSubmit={setShowReceiptAfterSubmit}
        finalTotal={finalTotal}
        handleSubmit={handleSubmit}
      />

      {showPriceWarning && (
        <PriceWarningModal
          t={t}
          onManual={() => {
            setShowPriceWarning(false);
            setTimeout(() => priceRef.current?.focus(), 100);
          }}
          onSettings={handleRedirectToSettings}
        />
      )}

      {showReceiptPopup && (
        <ReceiptModal
          t={t}
          Name={Name}
          onPrint={printReceipt}
          onShare={shareReceipt}
          onClose={() => setShowReceiptPopup(false)}
        />
      )}

      {isOpen && (
        <MissingCustomerModal t={t} onClose={() => setIsOpen(false)} />
      )}

      <ToastContainer position="top-center" transition={Bounce} />
    </div>
  );
}

export default MilkEntries;